import type { InputHTMLAttributes, ReactNode, Ref } from 'react';
import type { RadioSize } from './Radio.css';
import { root, rootDisabled, controlWrapper, nativeInput, ring, dot, labelText } from './Radio.css';

export type { RadioSize };

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  /** Ref to the underlying input */
  ref?: Ref<HTMLInputElement>;
  /** Visual size */
  radioSize?: RadioSize;
  /** Visible label rendered next to the control. Provide this or `aria-label` for accessibility. */
  label?: ReactNode;
  /** Custom class name applied to the root label */
  className?: string;
}

export function Radio({
  radioSize = 'md',
  disabled = false,
  label,
  className,
  ref,
  ...props
}: RadioProps) {
  return (
    <label
      className={`${root}${disabled ? ` ${rootDisabled}` : ''}${className ? ` ${className}` : ''}`}
    >
      <span className={controlWrapper}>
        <input ref={ref} type="radio" disabled={disabled} className={nativeInput} {...props} />
        <span className={ring[radioSize]} aria-hidden="true">
          <span className={dot} />
        </span>
      </span>
      {label != null && <span className={labelText[radioSize]}>{label}</span>}
    </label>
  );
}
